// extracted by mini-css-extract-plugin
export default {"control":"Control_control__h4nhc","button":"Control_button__qFSTG"};